import styled, { css } from 'styled-components';

import { Modal as BaseModal } from '@/components/Modal';

export const Desc = styled.p`
  ${({ theme }) => css`
    text-align: center;
    font-size: ${theme.fontSizes.p3};
    line-height: ${theme.lineHeights.p3};
    padding: ${theme.spacing(2)};
    a {
      font-weight: ${theme.fontWeights.bold};
    }
  `}
`;

export const Modal = styled(BaseModal)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    padding-block: ${theme.spacing(2, 0)};
    ${theme.media.sm.up} {
      display: block;
      flex-direction: unset;
      height: fit-content;
      padding-block: ${theme.spacing(2, 4)};
    }
  `}
`;
export const ModalBody = styled(BaseModal.Body)`
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
`;
export const ModalFooter = styled(BaseModal.Footer)`
  text-align: center;
`;
